import { render, staticRenderFns } from "./tablaPedidos.vue?vue&type=template&id=bbdced46&scoped=true"
import script from "./tablaPedidos.vue?vue&type=script&lang=js"
export * from "./tablaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdced46",
  null
  
)

export default component.exports